/**
 * botObjectiveBias — Soft pull toward enemy nexus when ahead (FID-BOT-06 / SPY-1415).
 */
import { biasAramLaneX } from './botLaneBias.js';

export const BOT_OBJECTIVE_BIAS_STRENGTH = 0.47;

function pointZ(p) {
  if (!p) return 0;
  if (Number.isFinite(p.z)) return p.z;
  return Number.isFinite(p.y) ? p.y : 0;
}

/**
 * @param {{ x: number, z: number }} target
 * @param {{ x: number, z: number }} objective
 * @param {{ strength?: number, laneBias?: boolean }} [opts]
 */
export function biasBotTowardObjective(target, objective, opts = {}) {
  const strength = opts.strength ?? BOT_OBJECTIVE_BIAS_STRENGTH;
  const s = Math.min(1, Math.max(0, Number.isFinite(strength) ? strength : BOT_OBJECTIVE_BIAS_STRENGTH));
  let x = target.x + (objective.x - target.x) * s;
  const z = target.z + (objective.z - target.z) * s;
  if (opts.laneBias !== false) x = biasAramLaneX(x);
  return { x, z };
}

/** Advance waypoint: interpolate bot → enemy spawn, then lane-center X. */
export function botAdvanceTarget(bot, enemySpawn) {
  return biasBotTowardObjective(
    { x: Number(bot?.x) || 0, z: pointZ(bot) },
    { x: Number(enemySpawn?.x) || 0, z: pointZ(enemySpawn) }
  );
}
